/**
 * Street-turned Import: no new legs.
 *
 * Once an import's container has been reused onto another pro (reuse pro # set),
 * work keyed against the import never surfaces on the pro that now owns the box
 * (Amber Brown, 2026-09-25, pro 5117478). The backend refuses the save
 * (saverules/leg_gates.py); this is the same rule so the UI can disable the add
 * controls up front and say where the leg belongs.
 *
 * Returns the user-facing reason, or null when adding a leg is allowed.
 */
export function streetTurnLegBlock(
  moveType: string | null | undefined,
  reuseContainerPro: number | string | null | undefined,
): string | null {
  if (String(moveType ?? '').trim().toUpperCase() !== 'IMPORT') return null;
  const reusePro = Number(reuseContainerPro ?? 0);
  if (!Number.isFinite(reusePro) || reusePro === 0) return null;
  return (
    `This Import has been street turned to pro ${reusePro}. ` +
    `Legs can't be added here. Add them on pro ${reusePro} instead.`
  );
}
